import React from 'react';
import MainFeatures from '../../components/Features';
import LeftImage from '../../components/Features/LeftImage';
import RightImage from '../../components/Features/RightImage';
import products from '../../data/products.json';

const Features = () => {
  return (
    <MainFeatures
      title={
        <>
          Top <span className="text-indigo-600">Features</span> of Google Drive
          Auditor
        </>
      }
      description="Protect your sensitive files in Google Drive from getting exposed!"
      link={products.GA06.install}
    >
      <RightImage
        title="Review File Permissions &nbsp; "
        image="GA06/file-properties.png"
        alt="Drive Permissions Report"
      >
        The drive audit report includes detailed information of every file
        including the owner&rsquo;s email, the location in Drive, the list of
        editors, viewers, commenters, and the kind of sharing permissions they
        have.
      </RightImage>
      <LeftImage
        title="Audit Logs in Sheets &nbsp;"
        image="GA06/drive-file-privacy-report.png"
        alt="Audit Log in Google Sheets"
      >
        The Drive auditor scans files and folders in your Google Drive and the
        audit logs permanently in a Google Sheet. Use filters in sheets to view
        files that are not private or shared with external users outside the
        organization.
      </LeftImage>

      <RightImage
        title="Advanced Search Operators &nbsp; "
        image="GA06/file-search-operators.png"
        alt="File Search Operators"
      >
        Use any of the advanced search operators of the Drive API (v3) and limit
        your audit to files and folders that match your search queries.
      </RightImage>
      <LeftImage
        title="Scan Google Shared Drives&nbsp;"
        image="GA06/shared-files.png"
        alt="Shared team drives are supported"
      >
        Google Shared Drives, formerly known as Team Drives, are a way to store
        and share files with a team. Google Drive auditor can also scan and
        audit files stored in shared drives.
      </LeftImage>
      <RightImage
        title="Private and Secure &nbsp; "
        image="google/security-letter.png"
        alt="Private and Secure"
      >
        The Google Drive Auditor runs directly in your Google Drive and does not
        use any external service to scan your files. All your data resides in
        the Google Sheet and not a byte is shared, accessed or uploaded
        anywhere.
      </RightImage>
    </MainFeatures>
  );
};

export default Features;
